import React from "react";
import { CPDropdown } from "../CPDropdown";
import { CPInput } from "../CPInput";
import { CPTextarea } from "../CPTextarea";
import {
  getPaymentMethodDefinition,
  PAYMENT_METHOD_OPTIONS,
} from "../../helpers/invoicePaymentInstructions";

/**
 * Shared payment-instructions fields for Admin + Invoice Review.
 * Field labels/kinds come from the payment method registry.
 * Ordinary text/textarea controls use canonical CPInput / CPTextarea.
 */
export function PaymentInstructionsFields({
  value,
  onChange,
  disabled = false,
  errors = {},
  variant = "dark",
}) {
  // variant retained for call-site compatibility (admin | dark); both use CP*.
  void variant;

  const config = value || {};
  const definition = getPaymentMethodDefinition(config.preferredMethod);
  const editorFields = definition?.editorFields || [];

  function patch(next) {
    onChange?.({
      preferredMethod: config.preferredMethod || "",
      paymentEmail: config.paymentEmail || "",
      additionalInstructions: config.additionalInstructions || "",
      customMethodLabel: config.customMethodLabel || "",
      ...next,
    });
  }

  return (
    <div>
      <CPDropdown
        label="Preferred payment method"
        value={config.preferredMethod || ""}
        disabled={disabled}
        onChange={(preferredMethod) => patch({ preferredMethod })}
        options={[
          { value: "", label: "Not configured" },
          ...PAYMENT_METHOD_OPTIONS,
        ]}
      />
      {errors.preferredMethod ? (
        <p className="admin-placeholder-note" style={{ color: "#f0a0a0" }}>
          {errors.preferredMethod}
        </p>
      ) : null}

      {editorFields.map((field) => (
        <div key={field.key}>
          {field.kind === "textarea" ? (
            <CPTextarea
              label={field.label}
              value={config[field.key] || ""}
              disabled={disabled}
              placeholder={field.placeholder || ""}
              rows={4}
              onChange={(nextValue) => patch({ [field.key]: nextValue })}
            />
          ) : (
            <CPInput
              label={field.label}
              type={field.kind === "email" ? "email" : "text"}
              value={config[field.key] || ""}
              disabled={disabled}
              placeholder={field.placeholder || ""}
              onChange={(nextValue) => patch({ [field.key]: nextValue })}
            />
          )}
          {errors[field.key] ? (
            <p className="admin-placeholder-note" style={{ color: "#f0a0a0" }}>
              {errors[field.key]}
            </p>
          ) : null}
        </div>
      ))}

      {definition?.showAdditionalInstructions ? (
        <CPTextarea
          label={
            definition.additionalInstructionsLabel ||
            "Additional payment instructions"
          }
          value={config.additionalInstructions || ""}
          disabled={disabled}
          placeholder="Optional details shown on the invoice"
          rows={4}
          onChange={(additionalInstructions) =>
            patch({ additionalInstructions })
          }
        />
      ) : null}
    </div>
  );
}
